module.exports = __webpack_public_path__ + "images/bubble_filler.gif";